import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const NavatarLoader = () => {
    return (_jsx(_Fragment, { children: _jsxs("span", { className: "awsm-ik-loader-container", "data-testid": "navatar-icon-loader", children: [_jsx("span", { className: "loader-circle loader-circle-left" }), _jsx("span", { className: "loader-circle loader-circle-right" })] }) }));
};
export default NavatarLoader;
//# sourceMappingURL=NavatarLoader.js.map